import { createTRPCReact } from '@trpc/react-query';

import type { AppRouter } from '@sternum/api/trpc/router';

export const trpc = createTRPCReact<AppRouter>();
